import React, { Fragment } from "react"
import { Page, Text, View, Document, StyleSheet } from "@react-pdf/renderer"

import PdfHeader from "./PdfHeader"
import PdfTable from "./PdfTable"
import PdfTotals from "./PdfTotals"

// Create styles
const styles = StyleSheet.create({
  page: {
    fontSize: "10px",
    padding: "40px",
    lineHeight: "1.2px",
    display: "flex",
    flexDirection: "column",
  },
  headingSection: {
    marginBottom: 10,
    padding: 10,
    display: "flex",
  },
  tableSection: {
    padding: 5,
  },
  actionsSection: {
    marginBottom: 10,
    marginTop: 10,
    border: "1px solid #9A9A9A",
    borderRadius: "4px",
    padding: 10,
    minHeight: 100,
  },
  expenseRow: {
    margin: "1px 0 0 20px",
    backgroundColor: "#FFF0EF",
    display: "flex",
    flexDirection: "row",
    flexGrow: 1,
    borderRadius: "4px",
    padding: "5px 10px",
  },
  expenseName: {
    width: "60%",
  },
  expenseNumberItem: {
    width: "20%",
    textAlign: "right",
  },
  pageNumber: {
    position: "absolute",
    fontSize: 10,
    bottom: 20,
    left: 0,
    right: 0,
    textAlign: "center",
    color: "grey",
  },
})

// Create Document Component
const SingleCrewPdf = ({ data = {} }) => {
  let type = data && data.type.toLowerCase()

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.headingSection}>
          <PdfHeader data={data} type={type} />
        </View>
        <View style={styles.tableSection}>
          {data &&
            data.expenses && <PdfTable expenses={data.expenses} type={type} />}
        </View>
        <View style={styles.tableSection}>
          {type.toLowerCase() === "crew-bill" && (
            <Fragment>
              {data &&
                data.additional_expenses && (
                  <PdfTable
                    expenses={data.additional_expenses}
                    type={type}
                    additional
                  />
                )}
            </Fragment>
          )}
        </View>
        <View
          wrap={false}
          style={{
            display: "flex",
            flexDirection: "row",
            paddingTop: 20,
            paddingBottom: 20,
            marginLeft: 10,
            marginRight: 10,
            justifyContent: "flex-end",
          }}
        >
          <View
            style={{
              display: "flex",
              flexDirection: "column",
              width: "40%",
            }}
          >
            <PdfTotals data={data} type={type} />
          </View>
        </View>
        <Text
          style={styles.pageNumber}
          render={({ pageNumber, totalPages }) =>
            `${pageNumber} / ${totalPages}`
          }
          fixed
        />
        <View>
          <Text>
            -Any additions, equipment or expenses need to be approved by your
            Crew Mama Rep prior to billing or time or use.
          </Text>
        </View>
        <View>
          <Text>
            -Canceled Bookings are charged: $100.00 72 hours before shoot, 50%
            of day rate 48 -71 hours before shoot, 100% of day rate 24-47 hours
            before shoot
          </Text>
        </View>
      </Page>
    </Document>
  )
}

export default SingleCrewPdf
